<div class="sabis-loader">
  @if (internal) {
    <div class="sabis-loader__inner-page">
      <img src="assets/loading/Pulse-1s-200px.svg" alt="Please wait..." />
      {{ text }}
    </div>
  } @else {
    <div class="sabis-loader__viewport">
      <img src="assets/loading/double-ring.svg" alt="Please wait..." />
      {{ text }}
    </div>
  }
</div>
